import { useMutation } from '@tanstack/react-query'

import fetchRequest from '@/app/_utils/fetch-request'

interface Props {
    productId: string
}
export default function useDeleteWishlist() {
    return useMutation({
        mutationFn: async ({ productId }: Props) =>
            fetchRequest({ method: 'DELETE', serviceName: 'ntl', endpoint: `/wishlist/product-id/${productId}` }),
    })
}
